"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var redux_1 = require("redux");

exports.asyncState = function (loading, data, error) {
  if (loading === void 0) {
    loading = false;
  }

  if (data === void 0) {
    data = null;
  }

  if (error === void 0) {
    error = '';
  }

  return {
    loading: loading,
    data: data,
    error: error
  };
};

var SET_LOADING = 'SET_LOADING';
var STOP_LOADING = 'STOP_LOADING';
var SET_ERROR = 'SET_ERROR';
var SET_DATA = 'SET_DATA';

exports.setLoading = function () {
  return {
    type: SET_LOADING
  };
};

exports.stopLoading = function () {
  return {
    type: STOP_LOADING
  };
};

exports.setError = function (payload) {
  return {
    type: SET_ERROR,
    payload: payload
  };
};

exports.setData = function (payload) {
  return {
    type: SET_DATA,
    payload: payload
  };
};

var actions = {
  setLoading: exports.setLoading,
  stopLoading: exports.stopLoading,
  setError: exports.setError,
  setData: exports.setData
};

exports.asyncReducer = function (state, action) {
  if (state === void 0) {
    state = exports.asyncState();
  }

  switch (action.type) {
    case SET_LOADING:
      return exports.asyncState(true);

    case STOP_LOADING:
      return exports.asyncState(false);

    case SET_DATA:
      return exports.asyncState(false, action.payload);

    case SET_ERROR:
      return exports.asyncState(false, null, action.payload);

    default:
      return state;
  }
};

exports.useAsyncReducer = function (initial) {
  if (initial === void 0) {
    initial = exports.asyncState();
  }

  var _a = react_1.useReducer(exports.asyncReducer, initial),
      state = _a[0],
      dispatch = _a[1];

  var boundActions = redux_1.bindActionCreators(actions, dispatch);
  return [state, boundActions];
};